import { render, staticRenderFns } from "./ReviewVideo.vue?vue&type=template&id=7c777704&scoped=true&"
import script from "./ReviewVideo.vue?vue&type=script&lang=js&"
export * from "./ReviewVideo.vue?vue&type=script&lang=js&"
import style0 from "./ReviewVideo.vue?vue&type=style&index=0&id=7c777704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c777704",
  null
  
)

export default component.exports